// extracted by mini-css-extract-plugin
export var Spinner = "Spinner_TIYRx";
export var spinner = "spinner_JlHKb";